import { render, staticRenderFns } from "./AutomatskiSlanjeLog.vue?vue&type=template&id=40039af0&scoped=true&"
import script from "./AutomatskiSlanjeLog.vue?vue&type=script&lang=js&"
export * from "./AutomatskiSlanjeLog.vue?vue&type=script&lang=js&"
import style0 from "./AutomatskiSlanjeLog.vue?vue&type=style&index=0&id=40039af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40039af0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular})
